import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const loginUser = createAsyncThunk('user/loginUser', async ({ email, password }, thunkAPI) => {
  const response = await fetch('/api/admin/sessions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  if (response.status !== 201) {
    return thunkAPI.rejectWithValue(false);
  }

  thunkAPI.dispatch(getAuthenticatedUser());
  return true;
});

export const getAuthenticatedUser = createAsyncThunk('user/getAuthenticatedUser', async () => {
  const response = await fetch(`/api/admin/sessions/current`);
  return await response.json();
});

export const logoutUser = createAsyncThunk('user/logoutUser', async () => {
  await fetch(`/api/admin/sessions/current`, {
    method: 'DELETE',
  });

  return true;
});

export const authSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    isLoading: true,
    isLoginLoading: false,
    error: false,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    addUserAction: (state, action) => {
      if (!state.user) {
        return;
      }

      state.user.userActions.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthenticatedUser.fulfilled, (state, action) => {
        const user = action.payload.user;
        state.user = user;
        state.isLoading = false;
      })
      .addCase(getAuthenticatedUser.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(loginUser.pending, (state) => {
        state.isLoginLoading = true;
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.error = false;
        state.isLoginLoading = false;
      })
      .addCase(loginUser.rejected, (state) => {
        state.error = 'Wrong email or password, please try again!';
        state.isLoginLoading = false;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
      });
  },
});

export const { setUser, addUserAction } = authSlice.actions;

export default authSlice.reducer;
